import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=5ca48516&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca48516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca48516')) {
      api.createRecord('5ca48516', component.options)
    } else {
      api.reload('5ca48516', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=5ca48516&scoped=true", function () {
      api.rerender('5ca48516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settlement/SearchBar.vue"
export default component.exports